import { Controller } from "@hotwired/stimulus"
import { unaccent } from "../unaccent.js"

// Connects to data-controller="list-filter"
//
// Hides items in the controller's scope whose match-value (or text
// content) doesn't contain the input string. Case- and accent-
// insensitive (uses the project unaccent map), so typing "bela
// fleck" matches "Béla Fleck". Used by the clients index to filter
// ~1000 entries on the fly without a server round trip.
//
// Markup:
//   <div data-controller="list-filter">
//     <input type="search"
//            data-list-filter-target="input"
//            data-action="input->list-filter#filter">
//     <a data-list-filter-target="item"
//        data-list-filter-match-value="some name">…</a>
//     <a data-list-filter-target="item"
//        data-list-filter-match-value="other name">…</a>
//   </div>
export default class extends Controller {
  static targets = ["input", "item"]

  filter() {
    const needle = this.normalize(this.inputTarget.value.trim())
    this.itemTargets.forEach((el) => {
      const haystack = this.normalize(el.dataset.listFilterMatchValue || el.textContent || "")
      if (needle === "" || haystack.includes(needle)) {
        el.hidden = false
      } else {
        el.hidden = true
      }
    })
  }

  normalize(str) {
    return unaccent(str).toLowerCase()
  }
}
